/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {EMPTY_PLACEHOLDER as SHARED_EMPTY_PLACEHOLDER} from 'shared/web';

/**
 * @about don't mistake with simple dash, some editors might display dash and em-dash the same
 * @returns EM-DASH
 */
export const EMPTY_PLACEHOLDER = SHARED_EMPTY_PLACEHOLDER;
